import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from '@app/core/api/rest.service';
import { PayloadTarif, PayloadTarifGruppe, PayloadTarifGruppeList } from '@app/modules/bestandsabfrage/maklertarife/tarife.dto';
import {
  FileBucketMetadata,
  KeyValue,
  MotorsteuerAbfrage,
  PartnerAdminCreate,
  PartnerAdminUpdate,
  PayloadAdresseChangeLogList,
  PayloadAdresseStrasseSearchResultList,
  PayloadArchivDocumentList,
  PayloadBankverbindungList,
  PayloadBenutzerList,
  PayloadBetreuer,
  PayloadFahrzeugResultList,
  PayloadFileBucketMetadataList,
  PayloadGebaeudeResultList,
  PayloadIndexResultList,
  PayloadIndexSearch,
  PayloadInteger,
  PayloadKeyValueStringList, PayloadKlauselList,
  PayloadMaklerFileList,
  PayloadMaklerPolizzeProvisionList,
  PayloadMaklerTeamList,
  PayloadMotorsteuer,
  PayloadPartnerAdminCreate,
  PayloadPartnerAdminList,
  PayloadPerson,
  PayloadPersonCreate,
  PayloadPersonPolizzeResultList, PayloadPersonReferatList,
  PayloadPersonResultList,
  PayloadPersonSchadenResultList,
  PayloadPersonSchadensatz,
  PayloadPoldruckOptions,
  PayloadPolizze,
  PayloadPolizzeAenderungen,
  PayloadPolizzeBuchungResultList,
  PayloadPolizzeMahnstandResultList,
  PayloadPolizzeMailingList,
  PayloadPolizzeOpostenSummen,
  PayloadPolizzePersonResultList, PayloadPolizzeProvisionList,
  PayloadPolizzeProvisionResultList,
  PayloadPolizzeResultList,
  PayloadPolizzeSchaden,
  PayloadPolizzeZusaetzlicheTexte,
  PayloadPositionResultList,
  PayloadQuestionsData,
  PayloadSchaden,
  PayloadSchadenResultList, PayloadSchadenzahlungDetail,
  PayloadString,
  PayloadStringList,
  PayloadTerminList,
  PayloadTodo,
  PayloadTodoKommentarList,
  PayloadTodoResultList,
  PayloadVertragResultList,
  PayloadVertreter,
  PayloadVertreterBuchungList,
  PersonCreate,
  QuestionsData, VersbestRequest
} from '@pezi/entities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestMaklerService extends RestService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  searchPersonMakler(searchParams: KeyValue<string, any>[]): Observable<PayloadPersonResultList> {
    const params = this.getKeyValueAsQueryParams(searchParams);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadPersonResultList>(
        this.baseUrl + '/makler/person/suche',
        options);
  }

  public getPersonMakler(personId: number): Observable<PayloadPerson> {
    return this.http
      .get<PayloadPerson>(this.baseUrl + '/makler/person/' + personId, this.httpOptions);
  }

  public getPersonMaklerPolizzen(personId: number): Observable<PayloadPersonPolizzeResultList> {
    return this.http
      .get<PayloadPersonPolizzeResultList>(this.baseUrl + '/makler/person/' + personId + '/polizzen', this.httpOptions);
  }

  public getPersonMaklerSchaden(personId: number): Observable<PayloadPersonSchadenResultList> {
    return this.http
      .get<PayloadPersonSchadenResultList>(this.baseUrl + '/makler/person/' + personId + '/schaden', this.httpOptions);
  }

  searchPolizzeMakler(searchParams: KeyValue<string, any>[]): Observable<PayloadPolizzeResultList> {
    const params = this.getKeyValueAsQueryParams(searchParams);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadPolizzeResultList>(
        this.baseUrl + '/makler/polizze/suche',
        options);
  }

  public getPolizzeMakler(polizzeId: number): Observable<PayloadPolizze> {
    return this.http
      .get<PayloadPolizze>(this.baseUrl + '/makler/polizze/' + polizzeId, this.httpOptions);
  }

  public getPolizzeVertraegeMakler(polizzeId: number): Observable<PayloadVertragResultList> {
    return this.http
      .get<PayloadVertragResultList>(this.baseUrl + '/makler/polizze/' + polizzeId + '/vertrag', this.httpOptions);
  }

  public getPolizzePositionenMakler(polizzeId: number, vertragId: number): Observable<PayloadPositionResultList> {
    return this.http
      .get<PayloadPositionResultList>(this.baseUrl + '/makler/polizze/' + polizzeId + '/vertrag/' + vertragId + '/position', this.httpOptions);
  }

  public getPolizzeSchadenMakler(polizzeId: number): Observable<PayloadPolizzeSchaden> {
    return this.http
      .get<PayloadPolizzeSchaden>(this.baseUrl + '/makler/polizze/' + polizzeId + '/schaden', this.httpOptions);
  }

  public getPolizzeOpostenMakler(polizzeId: number): Observable<PayloadPolizzeOpostenSummen> {
    return this.http
      .get<PayloadPolizzeOpostenSummen>(this.baseUrl + '/makler/polizze/' + polizzeId + '/oposten', this.httpOptions);
  }

  public getPolizzeAussenstandMakler(polizzeId: number): Observable<PayloadPolizzeOpostenSummen> {
    return this.http
      .get<PayloadPolizzeOpostenSummen>(this.baseUrl + '/makler/polizze/' + polizzeId + '/aussenstand', this.httpOptions);
  }

  public getPolDruckOptionsMakler(polint: number): Observable<PayloadPoldruckOptions> {
    return this.http
      .get<PayloadPoldruckOptions>(this.baseUrl + '/makler/polizze/' + polint + '/druck/options', this.httpOptions);
  }

  public getMaklerPolizzeProvision(polint: number): Observable<PayloadMaklerPolizzeProvisionList> {
    return this.http
      .get<PayloadMaklerPolizzeProvisionList>(this.baseUrl + '/makler/polizze/' + polint + '/provision', this.httpOptions);
  }

  public printGrueneKarteMakler(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/makler/polizze/' + polint + '/druck/gruenekarte', {
        ...this.httpOptions,
        observe:      'response',
        responseType: 'blob' as 'json'
      });
  }

  public printPolizzenAuskunftMakler(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/makler/polizze/' + polint + '/druck/auskunft', {
        ...this.httpOptions,
        observe:      'response',
        responseType: 'blob' as 'json'
      });
  }

  public printPolizzenDuplikatMakler(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/makler/polizze/' + polint + '/druck/duplikat', {
        ...this.httpOptions,
        observe:      'response',
        responseType: 'blob' as 'json'
      });
  }

  public printVersbestMakler(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/makler/polizze/' + polint + '/druck/versbest', {
        ...this.httpOptions,
        observe:      'response',
        responseType: 'blob' as 'json'
      });
  }

  public printStatusMakler(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/makler/polizze/' + polint + '/druck/status', {
        ...this.httpOptions,
        observe:      'response',
        responseType: 'blob' as 'json'
      });
  }

  searchSchadenMakler(searchParams: KeyValue<string, any>[]): Observable<PayloadSchadenResultList> {
    const params = this.getKeyValueAsQueryParams(searchParams);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadSchadenResultList>(
        this.baseUrl + '/makler/schaden/suche',
        options);
  }

  public getSchadenMakler(schadenId: number): Observable<PayloadSchaden> {
    return this.http
      .get<PayloadSchaden>(this.baseUrl + '/makler/schaden/' + schadenId, this.httpOptions);
  }

  public getSchadenMaklerDocuments(schadenId: number): Observable<PayloadArchivDocumentList> {
    return this.http
      .get<PayloadArchivDocumentList>(this.baseUrl + '/makler/schaden/' + schadenId + '/documents', this.httpOptions);
  }

  getBetreuerMaklerList(): Observable<PayloadPersonResultList> {
    return this.http
      .get<PayloadPersonResultList>(
        this.baseUrl + '/makler/betreuer',
        this.httpOptions);
  }

  public getBetreuerMakler(betreuerId: number): Observable<PayloadBetreuer> {
    return this.http
      .get<PayloadBetreuer>(this.baseUrl + '/makler/betreuer/' + betreuerId, this.httpOptions);
  }

  public getBetreuerMaklerVertreterList(betreuerId: number): Observable<PayloadPersonResultList> {
    return this.http
      .get<PayloadPersonResultList>(this.baseUrl + '/makler/betreuer/' + betreuerId + '/vertreter', this.httpOptions);
  }

  getVertreterMaklerList(): Observable<PayloadPersonResultList> {
    return this.http
      .get<PayloadPersonResultList>(
        this.baseUrl + '/makler/vertreter',
        this.httpOptions);
  }

  public getVertreterMakler(vertreterId: number): Observable<PayloadVertreter> {
    return this.http
      .get<PayloadVertreter>(this.baseUrl + '/makler/vertreter/' + vertreterId, this.httpOptions);
  }

  public getVertreterMaklerAuszahlungen(vertreterId: number): Observable<PayloadVertreterBuchungList> {
    return this.http
      .get<PayloadVertreterBuchungList>(this.baseUrl + '/makler/vertreter/' + vertreterId + '/auszahlungen', this.httpOptions);
  }

  public getVertreterMaklerProvisionen(vertreterId: number): Observable<PayloadVertreterBuchungList> {
    return this.http
      .get<PayloadVertreterBuchungList>(this.baseUrl + '/makler/vertreter/' + vertreterId + '/provision', this.httpOptions);
  }

  public getVertreterMaklerBankverbindung(vertreterId: number): Observable<PayloadBankverbindungList> {
    return this.http
      .get<PayloadBankverbindungList>(this.baseUrl + '/makler/vertreter/' + vertreterId + '/bankverbindung', this.httpOptions);
  }

  public getMaklerKontakteTeams(): Observable<PayloadMaklerTeamList> {
    return this.http
      .get<PayloadMaklerTeamList>(this.baseUrl + '/makler/kontakt/aktuell', this.httpOptions);
  }

  public getMaklerKontakteLeitung(): Observable<PayloadMaklerTeamList> {
    return this.http
      .get<PayloadMaklerTeamList>(this.baseUrl + '/makler/kontakt/leitung', this.httpOptions);
  }

  public downloadMaklerDocument(docId: string): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(`${this.baseUrl}/makler/download/download`,
        {
          ...this.httpOptions,
          params:       {docId},
          observe:      'response',
          responseType: 'blob' as 'json'
        });
  }

  public getMaklerBBRDocumentList(): Observable<PayloadMaklerFileList> {
    return this.http
      .get<PayloadMaklerFileList>(this.baseUrl + '/makler/download/bbr', this.httpOptions);
  }

  public getMaklerPBZDocumentList(): Observable<PayloadMaklerFileList> {
    return this.http
      .get<PayloadMaklerFileList>(this.baseUrl + '/makler/download/pbz', this.httpOptions);
  }

  public getMaklerOMDSDocumentList(): Observable<PayloadMaklerFileList> {
    return this.http
      .get<PayloadMaklerFileList>(this.baseUrl + '/makler/download/omds', this.httpOptions);
  }

  public getMaklerBedingungenDocumentList(): Observable<PayloadMaklerFileList> {
    return this.http
      .get<PayloadMaklerFileList>(this.baseUrl + '/makler/download/bedingungen', this.httpOptions);
  }

  public getMaklerProduktdatenblatt(): Observable<PayloadMaklerFileList> {
    return this.http
      .get<PayloadMaklerFileList>(this.baseUrl + '/makler/download/produktdatenblatt', this.httpOptions);
  }

  public getMaklerPolizzeWartungsdienste(policeId: number): Observable<PayloadPolizzeAenderungen> {
    return this.http
      .get<PayloadPolizzeAenderungen>(this.baseUrl + '/makler/polizze/' + policeId + '/wartungsdienste', this.httpOptions);
  }

  public getMaklerPolizzeMailings(policeId: number): Observable<PayloadPolizzeMailingList> {
    return this.http
      .get<PayloadPolizzeMailingList>(this.baseUrl + '/makler/polizze/' + policeId + '/mailings', this.httpOptions);
  }

  public getMaklerPolizzeTexte(policeId: number): Observable<PayloadPolizzeZusaetzlicheTexte> {
    return this.http
      .get<PayloadPolizzeZusaetzlicheTexte>(this.baseUrl + '/makler/polizze/' + policeId + '/texte', this.httpOptions);
  }

  public getMaklerPolizzePersonen(policeId: number): Observable<PayloadPolizzePersonResultList> {
    return this.http
      .get<PayloadPolizzePersonResultList>(this.baseUrl + '/makler/polizze/' + policeId + '/personen', this.httpOptions);
  }

  public getMaklerPolizzeFahrzeuge(policeId: number): Observable<PayloadFahrzeugResultList> {
    return this.http
      .get<PayloadFahrzeugResultList>(this.baseUrl + '/makler/polizze/' + policeId + '/objekte/fahrzeuge', this.httpOptions);
  }

  public getMaklerPolizzeGebauede(policeId: number): Observable<PayloadGebaeudeResultList> {
    return this.http
      .get<PayloadGebaeudeResultList>(this.baseUrl + '/makler/polizze/' + policeId + '/objekte/gebaeude', this.httpOptions);
  }

  public getMaklerPossiblekfztyp(): Observable<PayloadKeyValueStringList> {
    return this.http
      .get<PayloadKeyValueStringList>(this.baseUrl + '/makler/motorsteuer/possiblekfztyp', this.httpOptions);
  }

  public putMaklerMotorsteuerAbfrage(body: MotorsteuerAbfrage): Observable<PayloadMotorsteuer> {
    return this.http
      .put<PayloadMotorsteuer>(
        this.baseUrl + '/makler/motorsteuer/abfrage',
        body,
        this.httpOptions);
  }

  public getMaklerPolizzeStatus(policeId: number): Observable<PayloadString> {
    return this.http
      .get<PayloadString>(this.baseUrl + '/makler/polizze/' + policeId + '/status', this.httpOptions);
  }

  public getMaklerIndexPossibleType(): Observable<PayloadKeyValueStringList> {
    return this.http
      .get<PayloadKeyValueStringList>(this.baseUrl + '/makler/index/possibletypen', this.httpOptions);
  }

  public getMaklerIndexData(index: string): Observable<PayloadIndexResultList> {
    return this.http
      .get<PayloadIndexResultList>(this.baseUrl + '/makler/index/' + index, this.httpOptions);
  }

  public getMaklerIndexSearch(index: string, vondatum?: string, bisdatum?: string): Observable<PayloadIndexSearch> {
    const params = this.getKeyValueAsQueryParams([
      {
        key:   'vondatum',
        value: vondatum
      },
      {
        key:   'bisdatum',
        value: bisdatum
      }
    ]);

    const options = Object.assign({}, this.httpOptions, {params});
    return this.http
      .get<PayloadIndexSearch>(this.baseUrl + '/makler/index/' + index + '/datum', options);
  }

  public getMaklerPartnerTypes(): Observable<PayloadKeyValueStringList> {
    return this.http
      .get<PayloadKeyValueStringList>(this.baseUrl + '/makler/partner/typ', this.httpOptions);
  }

  public getMaklerPartner(): Observable<PayloadPartnerAdminList> {
    return this.http
      .get<PayloadPartnerAdminList>(this.baseUrl + '/makler/partner', this.httpOptions);
  }

  public getMaklerPartnerCreate(typ: string): Observable<PayloadPartnerAdminCreate> {
    return this.http
      .get<PayloadPartnerAdminCreate>(this.baseUrl + `/makler/partner/typ/${typ}/create`, this.httpOptions);
  }

  public createMaklerPartner(body: PartnerAdminCreate): Observable<PayloadInteger> {
    return this.http
      .post<PayloadInteger>(
        this.baseUrl + '/makler/partner',
        body,
        this.httpOptions);
  }

  public updateMaklerPartner(body: PartnerAdminUpdate): Observable<PayloadInteger> {
    return this.http
      .put<PayloadInteger>(
        this.baseUrl + '/makler/partner',
        body,
        this.httpOptions);
  }

  searchMaklerPartnerBetreuer(searchParams: KeyValue<string, any>[], typ: string): Observable<PayloadPersonResultList> {
    const params = this.getKeyValueAsQueryParams(searchParams);
    const options = Object.assign({}, this.httpOptions, {params});
    return this.http
      .get<PayloadPersonResultList>(this.baseUrl + `/makler/partner/typ/${typ}/betreuer/suche`, options);
  }

  public getMaklerPartnerBetreuerList(): Observable<PayloadPersonResultList> {
    return this.http
      .get<PayloadPersonResultList>(this.baseUrl + `/makler/partner/betreuer/list`, this.httpOptions);
  }

  public getMaklerOffertLoginURL(): Observable<PayloadString> {
    return this.http
      .get<PayloadString>(this.baseUrl + '/makler/offert/loginurl', this.httpOptions);
  }

  public getMaklerVertreterBBR(personId: number): Observable<PayloadMaklerFileList> {
    return this.http
      .get<PayloadMaklerFileList>(this.baseUrl + '/makler/vertreter/' + personId + '/bbr', this.httpOptions);
  }

  public getMaklerMahnstand(): Observable<PayloadPolizzeMahnstandResultList> {
    return this.http
      .get<PayloadPolizzeMahnstandResultList>(this.baseUrl + '/makler/mahnstand', this.httpOptions);
  }

  public getMaklerTarifGruppen(): Observable<PayloadTarifGruppeList> {
    return this.http
      .get<PayloadTarifGruppeList>(this.baseUrl + '/maklertarif/gruppen', this.httpOptions);
  }

  public getMaklerTarifGruppeDetail(id: string): Observable<PayloadTarifGruppe> {
    return this.http
      .get<PayloadTarifGruppe>(this.baseUrl + '/maklertarif/gruppe/detail/' + id, this.httpOptions);
  }

  public getMaklerTarifDetail(id: string): Observable<PayloadTarif> {
    return this.http
      .get<PayloadTarif>(this.baseUrl + '/maklertarif/detail/' + id, this.httpOptions);
  }

  public getMaklerSchadensatz(personId: number): Observable<PayloadPersonSchadensatz> {
    return this.http
      .get<PayloadPersonSchadensatz>(this.baseUrl + '/makler/person/' + personId + '/schadensatz', this.httpOptions);
  }

  public getMaklerRechner(): Observable<PayloadMaklerFileList> {
    return this.http
      .get<PayloadMaklerFileList>(this.baseUrl + '/makler/download/rechner', this.httpOptions);
  }

  public getMaklerDokumente(): Observable<PayloadMaklerFileList> {
    return this.http
      .get<PayloadMaklerFileList>(this.baseUrl + '/makler/download/dokumente', this.httpOptions);
  }

  public getMaklerIDD(): Observable<PayloadMaklerFileList> {
    return this.http
      .get<PayloadMaklerFileList>(this.baseUrl + '/makler/download/idd', this.httpOptions);
  }

  public getMaklerPolizzeDokumente(polizzeId: number): Observable<PayloadArchivDocumentList> {
    return this.http
      .get<PayloadArchivDocumentList>(this.baseUrl + '/makler/polizze/' + polizzeId + '/document', this.httpOptions);
  }

  public getMaklerHundehaftpflichtQuestions(polint: number): Observable<PayloadQuestionsData> {
    return this.http
      .get<PayloadQuestionsData>(this.baseUrl + '/makler/polizze/' + polint + '/druck/hundehaftpflichtquestions', this.httpOptions);
  }

  public generateMaklerHundehaftpflicht(polint: number, body: QuestionsData): Observable<PayloadFileBucketMetadataList> {
    return this.http
      .post<PayloadFileBucketMetadataList>(this.baseUrl + '/makler/polizze/' + polint + '/druck/hundehaftpflicht/generate', body, {
        ...this.httpOptions
      });
  }

  public downloadMaklerHundehaftpflicht(polint: number, file: FileBucketMetadata): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/makler/polizze/' + polint + '/druck/hundehaftpflicht/download', file, {
        ...this.httpOptions,
        observe:      'response',
        responseType: 'blob' as 'json'
      });
  }

  getTodo(todoId: number): Observable<PayloadTodo> {
    return this.http
      .get<PayloadTodo>(this.baseUrl + '/makler/todo/' + todoId, this.httpOptions);
  }

  getKommentarForTodo(todoId: number): Observable<PayloadTodoKommentarList> {
    return this.http
      .get<PayloadTodoKommentarList>(this.baseUrl + '/makler/todo/' + todoId + '/kommentar', this.httpOptions);
  }

  getTeilnehmerForTodo(todoId: number): Observable<PayloadBenutzerList> {
    return this.http
      .get<PayloadBenutzerList>(this.baseUrl + '/makler/todo/' + todoId + '/teilnehmer', this.httpOptions);
  }

  getOffeneTodosTeilnehmer(): Observable<PayloadTodoResultList> {
    return this.http
      .get<PayloadTodoResultList>(this.baseUrl + '/makler/todo/teilnehmer/offen', this.httpOptions);
  }

  getErledigteTodosTeilnehmer(): Observable<PayloadTodoResultList> {
    return this.http
      .get<PayloadTodoResultList>(this.baseUrl + '/makler/todo/teilnehmer/erledigt', this.httpOptions);
  }

  getLaender(): Observable<PayloadKeyValueStringList> {
    return this.http
      .get<PayloadKeyValueStringList>(this.baseUrl + '/makler/adresse/land', this.httpOptions);
  }

  getOrt(plz: string): Observable<PayloadStringList> {
    const params = this.getKeyValueAsQueryParams([
      {
        key:   'plz',
        value: plz
      } as KeyValue<string, string>
    ]);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadStringList>(this.baseUrl + '/makler/adresse/pac/ort', options);
  }

  getStrasse(plz: string, ort: string): Observable<PayloadStringList> {
    const params = this.getKeyValueAsQueryParams([
      {
        key:   'plz',
        value: plz
      },
      {
        key:   'ort',
        value: ort
      }
    ]);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadStringList>(this.baseUrl + '/makler/adresse/pac/strasse', options);
  }

  getHausnr(plz: string, ort: string, strasse: string): Observable<PayloadStringList> {
    const params = this.getKeyValueAsQueryParams([
      {
        key:   'plz',
        value: plz
      },
      {
        key:   'ort',
        value: ort
      },
      {
        key:   'strasse',
        value: strasse
      }
    ]);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadStringList>(this.baseUrl + '/makler/adresse/pac/hausnr', options);
  }

  getPac(plz: string, ort: string, strasse: string, hausnr: string): Observable<PayloadStringList> {
    const params = this.getKeyValueAsQueryParams([
      {
        key:   'plz',
        value: plz
      },
      {
        key:   'ort',
        value: ort
      },
      {
        key:   'strasse',
        value: strasse
      },
      {
        key:   'hausnr',
        value: hausnr
      }
    ]);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadStringList>(this.baseUrl + '/makler/adresse/pac', options);
  }

  getPacTuerNr(pacId: string): Observable<PayloadStringList> {
    return this.http
      .get<PayloadStringList>(this.baseUrl + '/makler/adresse/pac/' + pacId + '/tuernr', this.httpOptions);
  }

  searchPacAdr(searchText: string): Observable<PayloadAdresseStrasseSearchResultList> {
    const params = this.getKeyValueAsQueryParams([
      {
        key:   'searchtext',
        value: searchText
      } as KeyValue<string, string>
    ]);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadAdresseStrasseSearchResultList>(this.baseUrl + '/makler/adresse/pac/search', options);
  }

  getAdresseChangelog(adresseId: number): Observable<PayloadAdresseChangeLogList> {
    return this.http
      .get<PayloadAdresseChangeLogList>(this.baseUrl + '/makler/adresse/changelog/' + adresseId, this.httpOptions);
  }

  searchBeitragszahler(searchParams: KeyValue<string, any>[]): Observable<PayloadPersonResultList> {
    const params = this.getKeyValueAsQueryParams(searchParams);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadPersonResultList>(
        this.baseUrl + '/makler/person/suche/beitragszahler',
        options);
  }

  public getPersonCreateNat(): Observable<PayloadPersonCreate> {
    return this.http
      .get<PayloadPersonCreate>(
        this.baseUrl + '/makler/person/create/nat', this.httpOptions);
  }

  public getPersonCreateJur(): Observable<PayloadPersonCreate> {
    return this.http
      .get<PayloadPersonCreate>(
        this.baseUrl + '/makler/person/create/jur', this.httpOptions);
  }

  public createPerson(person: PersonCreate): Observable<PayloadPersonCreate> {
    return this.http
      .put<PayloadPersonCreate>(
        this.baseUrl + '/makler/person/create',
        person,
        this.httpOptions);
  }

  public printGebaeudebewertung(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/makler/polizze/' + polint + '/druck/gebaeudebewertung', {
        ...this.httpOptions,
        observe:      'response',
        responseType: 'blob' as 'json'
      });
  }

  public printBedingungen(polint: number): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/makler/polizze/' + polint + '/druck/bedingungen', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public getMaklerBuchungen(polint: number): Observable<PayloadPolizzeBuchungResultList> {
    return this.http
      .get<PayloadPolizzeBuchungResultList>(this.baseUrl + '/makler/polizze/' + polint + '/buchungen', this.httpOptions);
  }

  public getMaklerTermineInkasso(polint: number): Observable<PayloadTerminList> {
    return this.http
      .get<PayloadTerminList>(this.baseUrl + '/makler/polizze/' + polint + '/termine/inkasso', this.httpOptions);
  }

  public getMaklerProvisionBuchungen(polint: number): Observable<PayloadPolizzeProvisionResultList> {
    return this.http
      .get<PayloadPolizzeProvisionResultList>(this.baseUrl + '/makler/polizze/' + polint + '/provision/buchung', this.httpOptions);
  }

  public getMaklerPolizzeAenderungen(polint: number): Observable<PayloadPolizzeAenderungen> {
    return this.http
      .get<PayloadPolizzeAenderungen>(this.baseUrl + '/makler/polizze/' + polint + '/aenderungen', this.httpOptions);
  }

  public getSchadenFormQuestions(polint: number): Observable<PayloadQuestionsData> {
    return this.http
      .get<PayloadQuestionsData>(this.baseUrl + '/makler/polizze/' + polint + '/druck/schadenform', this.httpOptions);
  }

  public generateSchadenFormQuestions(polint: number, body: QuestionsData): Observable<PayloadFileBucketMetadataList> {
    return this.http
      .post<PayloadFileBucketMetadataList>(this.baseUrl + '/makler/polizze/' + polint + '/druck/schadenform/generate', body, {
        ...this.httpOptions
      });
  }

  public downloadSchadenFormQuestions(polint: number, file: FileBucketMetadata): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/makler/polizze/' + polint + '/druck/schadenform/download', file, {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public getPersonBankverbindungen(personId: number): Observable<PayloadBankverbindungList> {
    return this.http
      .get<PayloadBankverbindungList>(
        this.baseUrl + '/makler/person/' + personId + '/bankverbindung', this.httpOptions);
  }

  public getMailingsForPerson(personId: number): Observable<PayloadPolizzeMailingList> {
    return this.http
      .get<PayloadPolizzeMailingList>(
        this.baseUrl + '/makler/person/' + personId + '/mailings', this.httpOptions);
  }

  public getPolizzeTermine(polint: number): Observable<PayloadTerminList> {
    return this.http
      .get<PayloadTerminList>(this.baseUrl + '/makler/polizze/' + polint + '/termine', this.httpOptions);
  }

  public getKlauselnForPolice(polint: number): Observable<PayloadKlauselList> {
    return this.http
      .get<PayloadKlauselList>(this.baseUrl + '/makler/polizze/' + polint + '/klausel', this.httpOptions);
  }

  public printKlausel(polint: number, klausel: string): Observable<HttpResponse<Blob>> {
    return this.http
      .get<Blob>(this.baseUrl + '/makler/polizze/' + polint + '/klausel/' + klausel + '/druck', {
        ...this.httpOptions,
        observe: 'response',
        responseType: 'blob' as 'json'
      });
  }

  public getReferate(polint: number): Observable<PayloadPersonReferatList> {
    return this.http
      .get<PayloadPersonReferatList>(this.baseUrl + '/makler/polizze/' + polint + '/referate', this.httpOptions);
  }

  public getSchadenZahlungDetail(schadenNr: number, zahlungId: number): Observable<PayloadSchadenzahlungDetail> {
    return this.http
      .get<PayloadSchadenzahlungDetail>(this.baseUrl + '/makler/schaden/' + schadenNr + '/zahlung/' + zahlungId, this.httpOptions);
  }

  public getPersonInfoBrief(personId: number): Observable<PayloadPolizzeMailingList> {
    return this.http
      .get<PayloadPolizzeMailingList>(
        this.baseUrl + '/makler/person/' + personId + '/mailings/infobrief', this.httpOptions);
  }

  public getMaklerProvisionenDetailList(polizzeId: number): Observable<PayloadPolizzeProvisionList> {
    return this.http
      .get<PayloadPolizzeProvisionList>(
        this.baseUrl + '/makler/polizze/' + polizzeId + '/provision/detail', this.httpOptions);
  }

  public downloadVersicherungsbestaetigung(request: VersbestRequest): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/makler/versbest/download',
        request,
        {
          ...this.httpOptions,
          observe:      'response',
          responseType: 'blob' as 'json'
        });
  }

}
